'use client';

import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { resolveText } from '@macaron-a2ui/core/v0_8';
import type { MacaronRenderContext, RecordAny } from '@macaron-a2ui/core/v0_8';

export function MacaronMarkdownView({ config, ctx }: { config: RecordAny; ctx: MacaronRenderContext }) {
  const value = resolveText(config.text, ctx.data);
  if (!value) return null;

  return (
    <div className="w-full rounded-lg border border-[#EAECF0] bg-white p-3 font-sans text-[14px] leading-6 text-[#344054]">
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={{
          a: ({ children }) => <span className="underline">{children}</span>,
          p: ({ children }) => <p className="mb-3 last:mb-0">{children}</p>,
          ul: ({ children }) => <ul className="mb-3 list-disc pl-5 last:mb-0">{children}</ul>,
          ol: ({ children }) => <ol className="mb-3 list-decimal pl-5 last:mb-0">{children}</ol>,
          li: ({ children }) => <li className="mb-1 last:mb-0">{children}</li>,
          blockquote: ({ children }) => <blockquote className="mb-3 border-l-2 border-[#D0D5DD] pl-3 italic last:mb-0">{children}</blockquote>,
          code: ({ className, children }) =>
            !className && !String(children).includes('\n') ? (
              <code className="rounded bg-[#F3F4F6] px-1 py-0.5 text-[13px] text-[#161615]">{children}</code>
            ) : (
              <code className="block overflow-x-auto rounded-lg bg-[#F3F4F6] p-3 text-[13px] text-[#161615]">{children}</code>
            ),
        }}
      >
        {value}
      </ReactMarkdown>
    </div>
  );
}
